import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { delay, reduce } from 'lodash';
import { connect } from 'react-redux';
import { AgGridReact } from 'ag-grid-react';
import Fa from 'react-fontawesome';
import { Modal, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import ProgressBar from '../../../../components/progress-bar';
import SearchField from '../../../../components/search-field';
import NumberDisplay from '../../../../components/number-display';
import { loadMetaData, updateMassMetaData } from '../../SetupActions';
import APINameStarRenderer from '../../components/cells/APICellRenderer';


function FieldLabelRenderer(props) {
  const { data } = props;
  const tooltip = (
    <Tooltip id={`${data.name}_tooltip`}>{data.description}</Tooltip>
  );
  const lbl = data.label;
  let starComp = (<Fa name="star" className="invisible" />);
  if (data.is_trusales === true) {
    const truSalesTooltip = (
      <Tooltip id="trusales-tooltip">TruVoice Automation Internal Field</Tooltip>
    );
    starComp = (
      <OverlayTrigger placement="right" overlay={truSalesTooltip}>
        <Fa name="star" className="text-warning" />
      </OverlayTrigger>
    );
  }
  return (
    <span>
      {starComp}&nbsp;&nbsp;
      {lbl}&nbsp;
      {data.description !== undefined &&
        data.description !== null &&
        data.description.length > 0 &&
        <OverlayTrigger placement="right" overlay={tooltip}><Fa name="info-circle" className="text-active" /></OverlayTrigger>
      }
    </span>
  );
}
FieldLabelRenderer.propTypes = {
  data: PropTypes.shape({
    _id: PropTypes.string,
    description: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    is_trusales: PropTypes.bool,
  }),
};
FieldLabelRenderer.defaultProps = {
  data: null,
};


const initState = {
  loaded: false,
  loading: false,
  errors: null,
  results: [],
  show: false,
  selectedRows: [],
  adding: false,
};

class AddCustomObjectButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...initState,
    };
    this.close = this.close.bind(this);
    this.onEntered = this.onEntered.bind(this);
    this.onExited = this.onExited.bind(this);
    this.show = this.show.bind(this);
    this.onGridReady = this.onGridReady.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.onSelectionChanged = this.onSelectionChanged.bind(this);
    this.add = this.add.bind(this);
  }

  loadData() {
    this.setState({ loading: true, loaded: false, errors: null, results: [] }, () => {
      this.props.dispatch(loadMetaData({ syncRequired: false }))
        .then(
          (results) => {
            this.setState({ loading: false, loaded: false, errors: null, results }, () => {
              this.autoSize();
            });
          },
          (errors) => {
            this.setState({ loading: false, loaded: false, errors, results: [] });
          },
        )
    });
  }

  onSelectionChanged() {
    const selectedRows = this.gridApi.getSelectedRows();
    this.setState({ selectedRows });
    this.autoSize(false);
  }

  autoSize(d = true) {
    delay(() => {
      if (this.gridApi && this.gridColumnApi) {
        this.gridApi.sizeColumnsToFit();
      }
    }, d ? 100 : 0);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  handleSearch(query) {
    if (this.gridApi) {
      this.gridApi.setQuickFilter(query);
      this.autoSize();
    }
  }

  show() {
    this.setState({ show: true });
  }
  
  close() {
    this.setState({ show: false });
  }

  onExited() {
    this.setState({ ...initState });
  }

  onEntered() {
    if (!this.state.loading && !this.state.loaded) {
      this.loadData();
    }
  }

  add() {
    if (!this.state.adding) {
      this.setState({ adding: true }, () => {
        const selectedRows = this.gridApi.getSelectedRows();
        const params = reduce(selectedRows, (items, row) => {
          items.push({
            name: row.name,
            sync_required: true,
          })
          return items;
        }, []);
        this.props.dispatch(updateMassMetaData(params))
          .then(
            (results) => {
              this.props.onSuccess(results);
              this.close();
            },
            (e) => {
              // this.props.onError(e);
              const message = e.data ? e.data.message || e.data : 'Please try again';
              const el = (<div>{message}</div>);
              this.context.addNotification(el, { type: 'error', autoClose: false });
              this.setState({ adding: false });
            },
          );
      });
    }
  }

  renderLoading() {
    const content = (
      <div>
        <p><em>One moment please...</em></p>
        <p />
        <ProgressBar />
      </div>
    );
    return this.renderEmptyModal(content);
  }


  renderInstruction() {
    return (
      <div className="well well-sm">
        <div>
          <p>
            Please select the object(s) you want to add to TruVoice Automation sync
          </p>
        </div>
      </div>
    );
  }

  renderEmptyModal(content = null) {
    return (
      <div>
        <Modal.Body>
          {content}
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="default" onClick={this.close}>Close</Button>
        </Modal.Footer>
      </div>
    );
  }


  renderErrors() {
    const { errors } = this.state;
    if (!errors) {
      return null;
    }
    const message = errors.data ? errors.data.message : errors.message;

    const content = (
      <div className="alert alert-danger">
        {message}
      </div>
    );
    return this.renderEmptyModal(content);
  }

  renderResults() {
    const { results, selectedRows, adding } = this.state;
    if (!results || results.length === 0) {
      const content = (
        <div className="alert alert-danger">No data found</div>
      );
      return this.renderEmptyModal(content);
    }

    const columnDefs = [
      {
        headerName: '',
        width: 40,
        field: '_',
        suppressSorting: true,
        suppressMenu: true,
        suppressResize: true,
        checkboxSelection: true,
      },
      {
        headerName: 'Object Name',
        width: 200,
        field: 'label',
        autoHeight: false,
        cellRenderer: FieldLabelRenderer,
        suppressSorting: true,
        suppressMenu: true,
      },
      {
        headerName: 'API Name',
        width: 184,
        field: 'name',
        cellRenderer: APINameStarRenderer,
        suppressSorting: true,
        suppressMenu: true,
      },
    ];
    const hasSelected = selectedRows.length > 0;

    return (
      <div>
        <Modal.Body>
          <div>
            <nav className="navbar navbar-default navbar-controls">
              <div className="navbar-form navbar-left">
                <SearchField collapsible={false} onSearch={this.handleSearch} />
              </div>
            </nav>
            <div className="ag-theme-alpine" style={{ height: 300, width: '100%' }} >
              <AgGridReact
                reactNext
                enableColResize
                onGridReady={this.onGridReady}
                rowMultiSelectWithClick
                rowSelection="multiple"
                groupMultiAutoColumn
                rowDeselection
                columnDefs={columnDefs}
                rowData={results}
                onSelectionChanged={this.onSelectionChanged}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="clearfix">
            <Button className="pull-left" bsStyle="default" onClick={this.close}>Close</Button>
            {hasSelected &&
              <Button disabled={adding} className="pull-right" bsStyle="primary" onClick={this.add}>
                <Fa name={adding ? 'spinner' : 'plus'} spin={adding} /> Add <NumberDisplay value={selectedRows.length} precision={0} suffix="object" suffixIsUnit />
              </Button>  
            }
            {!hasSelected && <Button className="pull-right" disabled bsStyle="primary"><Fa name="plus" /> Add Object</Button>}
          </div>
        </Modal.Footer>
      </div>
    );
  }


  renderContent() {
    const { loading, loaded, errors } = this.state;
    if (loading) {
      return this.renderLoading();
    }
    if (!loaded && errors) {
      return this.renderErrors();
    }
    return this.renderResults();
  }


  renderModal() {
    const { show } = this.state;

    return (
      <Modal key="modal" show={show} onEntering={this.onEntered} onExited={this.onExited} onHide={this.close}>
        <Modal.Header closeButton>
          <h4>Add Objects to TruVoice Automation Sync</h4>
        </Modal.Header>
        {this.renderContent()}
      </Modal>
    );
  }



  render() {
    return [
      (
        <Button onClick={this.show} key="button" bsStyle="primary">
          <Fa name="plus" /> Add Objects
        </Button>
      ),
      this.renderModal(),
    ];
  }
}

// Retrieve data from store as props
function mapStateToProps() {
  return {
  };
}

AddCustomObjectButton.propTypes = {
  dispatch: PropTypes.func.isRequired,
  onSuccess: PropTypes.func,
};

AddCustomObjectButton.defaultProps = {
  onSuccess: () => {},
};

AddCustomObjectButton.contextTypes = {
  addNotification: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(AddCustomObjectButton);
